.signinSignupButtons {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  & > :not(:first-child) {
    margin-left: 10px;
  }
}
